<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.6353 11.753C13.3487 12.0861 12.8217 12.5489 12.1705 12.9311C11.5201 13.3127 10.6943 13.6435 9.81927 13.6438C8.94577 13.6439 8.10668 13.3146 7.44886 12.9333C6.79491 12.5540 6.25364 12.0842 5.98189 11.7273L6.84907 11.0667C7.01037 11.2785 7.42801 11.6603 7.99538 11.9894C8.55941 12.3164 9.20718 12.5529 9.81927 12.5529C10.4295 12.5526 11.061 12.3172 11.6186 11.9905C12.1743 11.6643 12.6063 11.2765 12.8086 11.0412L13.6353 11.753Z"
            :fill="color" />
        <path
            d="M6.77664 7.88353C7.31152 7.88353 7.74596 8.31707 7.74609 8.85192C7.74609 9.38691 7.31161 9.82136 6.77664 9.82136C6.24178 9.82122 5.8096 9.38686 5.8096 8.85192C5.80974 8.31716 6.24186 7.88367 6.77664 7.88353Z"
            :fill="color" />
        <path
            d="M13.005 7.88353C13.5397 7.88367 13.9718 8.31716 13.972 8.85192C13.972 9.38686 13.5398 9.82122 13.005 9.82136C12.47 9.82136 12.0362 9.38691 12.0362 8.85192C12.0364 8.31707 12.4701 7.88353 13.005 7.88353Z"
            :fill="color" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.81818 0C10.7219 0 11.4545 0.732625 11.4545 1.63636C11.4545 2.34852 10.9987 2.95196 10.3636 3.17684V4.78551H17.4545C17.8161 4.78551 18.1086 5.07814 18.1086 5.43963V8.18018C18.9617 8.23618 19.6364 8.95313 19.6364 9.82025C19.6364 10.6874 18.9616 11.4034 18.1086 11.4594V15.6723C18.1086 16.0338 17.8161 16.3274 17.4545 16.3274H12.1417L7.7514 19.084C7.55302 19.2091 7.30309 19.2191 7.09624 19.1081C6.88936 18.9972 6.75775 18.7859 6.75 18.5519L6.67649 16.3274H2.18182C1.82033 16.3274 1.52773 16.0338 1.52773 15.6723V11.4594C0.674716 11.4034 0 10.6874 0 9.82025C0 8.95313 0.674679 8.23618 1.52773 8.18018V5.43963C1.52773 5.07814 1.82033 4.78551 2.18182 4.78551H9.27273V3.17684C8.63763 2.95196 8.18182 2.34852 8.18182 1.63636C8.18182 0.732625 8.91444 0 9.81818 0ZM2.83594 15.0181H7.30928L7.44366 15.0309C7.73024 15.0894 7.95319 15.342 7.96343 15.6509L8.02898 17.3704L11.6058 15.118L11.6868 15.0745C11.7704 15.0373 11.8619 15.0181 11.9542 15.0181H16.7995V6.09461H2.83594V15.0181Z"
              :fill="color" />
    </svg>
</template>
<script>
export default {
    name: "ChatbotIcon",
    props: {
        color: {
            type: String,
            default: "#3A3F48",
        },
    },
};
</script>
<style scoped>
</style>
